import React from 'react';
import Card from '../../common/components/Card';
import JobQueueMonitor from './JobQueueMonitor';

const JobQueuePage = () => (
  <Card floating title="Job Queue" border padded>
    <JobQueueMonitor />
  </Card>
);

export default JobQueuePage;
